export default __webpack_public_path__ + "static/media/loading.372b42cf.gif";